<template>
  <a-modal
    :visible="visible"
    title="好友列表"
    @cancel="handleCancel"
    @ok="handleOkFriend"
    width="500px"
    okText="确定"
    cancelText="取消"
  >
 

  <div class="list">
    <ul  class="no-bullets">
      <li
        v-for="target in targetIdsList"
      >
      <div class="target-info">
        <span class="target-name">{{ target.userName }}</span>
        <span class="target-nickname" v-if="target.userNick">
          ({{ target.userNick }})
        </span>
        <a-button type="link" @click="showEditNameModal(target)">
          <EditOutlined />编辑联系人
        </a-button>

      </div>

      </li>
    </ul>
  </div>
  
  </a-modal>

  <EditNameModal
  v-model:visible="editNameModalVisible"
  @refreshFriendList="refreshFriendList"
/>
  
</template>

<script lang="ts" setup>
import { ref,watch,onMounted,computed,provide, reactive, defineProps, defineEmits } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { useStore } from 'vuex';
import { EditOutlined } from "@ant-design/icons-vue";
import EditNameModal from "./EditNameModal.vue";
const editNameModalVisible = ref(false);
const client = TelegramClient.getInstance();
const store = useStore();
  // 定义接口 (类型)
  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  

  // 过滤后的会话列表 (计算属性)
  const sessions = computed<Session[]>(() => {
    const filterKey = store.state.filterKey;
    return store.state.sessions.filter((session: Session) =>
      session.user.name.includes(filterKey)
    );
  });


  interface UserInfo {
	   userId:number;	// 用户ID 聊天唯一ID
     phone:string;	// 手机号
     userName:string;	// 用户名
     userNick:string;	// 用户昵称
     isContact:boolean;	// 是否为联系人
}

const curSelectUser = ref<UserInfo>();
provide('curSelectUser', curSelectUser); // 提供数据


const targetIdsList = ref<UserInfo[]>([]);



const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "success"): void;
}>();

 
const refreshFriendList = ()=>{
  handleGetContacts();
  console.log("refreshFriendList");
}


// 发送验证码
const handleSendCode = async () => {
 
};

onMounted(() => {
   

});


const showEditNameModal = (target: any) => {
   console.log("showEditNameModal");
   curSelectUser.value = target;
   var tt = target.userId;
   editNameModalVisible.value = true;

};


const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
};


const handleOkFriend = () => {
  emit("update:visible", false);
};

 
const handleGetContacts = async ()=>
{
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendGetTelegramContacts(
      account,
      name
    );
    if(result.message && result.message.list)
    {
      targetIdsList.value = result.message.list;
    }
    console.log("handleGetContacts");
}


// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      handleGetContacts();
       
    }
  }
);

 
 
</script>

<style scoped>
 
.list { 

  height: 510px; /* 设置容器高度，可以根据需要调整 */
  overflow-y: auto; /* 垂直方向滚动 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
   

  li {
    padding: 12px 15px;
    border-bottom: 1px solid #292C33;
    cursor: pointer;
    transition: background-color 0.1s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.03);
    }

    &.active {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  .avatar,
  .name {
    vertical-align: middle;
  }

  .avatar {
    border-radius: 2px;
  }

  .name {
    display: inline-block;
    margin: 0 0 0 15px;
  }

  .no-bullets {
    list-style-type: none;
    padding-left: 0; /* 移除默认的缩进 */
  }
}

</style>
